import { BaseScene } from './BaseScene.js';
import { UiKit } from './UiKit.js';
import { getSceneRouter } from './SceneRouter.js';
import { rewardCopy } from './rewardCopy.js';

/** Ekran nagrody — PL; przy 0 zł jasny komunikat zamiast „+0 zł". */
export class RewardScene extends BaseScene {
  static readonly KEY = 'Reward';

  constructor() {
    super(RewardScene.KEY);
  }

  create(
    data: {
      rewardZl?: number;
      returnTo?: string;
      errorMessage?: string;
    } = {},
  ): void {
    const { title, subtitle } = rewardCopy({
      rewardZl: data.rewardZl ?? 0,
      errorMessage: data.errorMessage,
    });

    this.paintStub(0xffe4f0, title, subtitle);
    UiKit.button(this, {
      x: this.gameW / 2,
      y: this.gameH / 2 + 100,
      label: 'Dalej',
      onClick: () => getSceneRouter().go(data.returnTo ?? 'Town'),
    });
  }
}
